import { AuthError } from '#pplx/frontend/auth/errors.js';
import { normalizeEnterpriseSession } from '#pplx/frontend/auth/subscriptionTier.js';
import { FetcherError } from '#pplx/frontend/fetcher/errors.js';
import { authClient } from '#pplx_generated/typespec/rest/auth/client.js';
const MAX_SESSION_ATTEMPTS = 2;
const MAX_CSRF_ATTEMPTS = 2;
const MAX_PROVIDERS_ATTEMPTS = 2;
export async function getCsrfToken() {
    const { data, error } = await authClient.GET('/api/auth/csrf', 'getCsrfToken', {
        numRetries: MAX_CSRF_ATTEMPTS,
        backOffTime: 500,
    });
    if (error) {
        throw new AuthError('CSRF_TOKEN_ERROR', {
            cause: error,
        });
    }
    return data.csrfToken;
}
export async function getProviders() {
    const { data, error } = await authClient.GET('/api/auth/providers', 'getProviders', {
        numRetries: MAX_PROVIDERS_ATTEMPTS,
        backOffTime: 500,
    });
    if (error) {
        throw new AuthError('GET_PROVIDERS_ERROR', {
            cause: error,
        });
    }
    return data;
}
export async function getSession() {
    try {
        const { data, error, response } = await authClient.GET('/api/auth/session', 'getSession', {
            numRetries: MAX_SESSION_ATTEMPTS,
            backOffTime: 500,
        });
        if (error) {
            throw new AuthError('AUTH_FETCH_ERROR', {
                details: {
                    status: response.status,
                },
                cause: error,
            });
        }
        return normalizeEnterpriseSession(Object.keys(data).length > 0 ? data : null);
    }
    catch (error) {
        if (error instanceof AuthError) {
            throw error;
        }
        switch (error?.code) {
            case 'FETCHER_MAX_RETRIES_EXCEEDED':
                throw new AuthError('AUTH_MAX_RETRIES_EXCEEDED_ERROR', {
                    cause: error,
                });
            case 'FETCHER_NO_STATUS_CODE_ERROR':
                throw new AuthError('AUTH_NO_STATUS_CODE_ERROR', {
                    cause: error,
                });
            default:
                throw new AuthError('AUTH_FETCH_ERROR', {
                    cause: error,
                });
        }
    }
}
export async function submitSignIn({ authorizationParams, body, provider, signInUrl, }) {
    return authClient.POST(signInUrl, 'signIn', {
        params: {
            path: {
                provider,
            },
            query: authorizationParams,
        },
        body,
        redirect: 'manual',
    });
}
export async function submitSignOut({ callbackUrl, csrfToken, }) {
    const { error } = await authClient.POST('/api/auth/signout', 'signOut', {
        body: {
            csrfToken,
            callbackUrl,
            json: 'true',
        },
        redirect: 'manual',
    });
    if (error) {
        throw new AuthError('SIGN_OUT_ERROR', {
            cause: error,
        });
    }
}
//# sourceMappingURL=core.js.map